import { ListInterfacesOutput } from "@zapier/bff";
import { trpc } from "../trpc";

type QueryInterfacesCache = ListInterfacesOutput | undefined;

const removeInterfaceFromSearchQueryResults = (
  cache: QueryInterfacesCache,
  id: string,
): QueryInterfacesCache => {
  if (!cache) {
    return cache;
  }

  return {
    ...cache,
    results: cache.results.filter(
      (interfaceObject) => interfaceObject.id !== id,
    ),
    meta: {
      ...cache.meta,
      count: cache.meta.count - 1,
    },
  };
};

interface Input {
  folderId?: string; // used for cache invalidation in mutations
}

export const useDeleteInterface = (input?: Input) => {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  return trpc.interface.delete.useMutation({
    onMutate: ({ id }) => {
      utils.interface.list.cancel();
      // Remove interface from the interface query search results cache
      utils.interface.list.setData({}, (cache: QueryInterfacesCache) =>
        removeInterfaceFromSearchQueryResults(cache, id),
      );
    },
    onSettled: () => {
      utils.interface.list.invalidate();

      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({ folderId });
      }
    },
  });
};
